/*
  Clean Cream — show subscription cadences shortest-first (month, 6 weeks,
  2 months) regardless of the order the app stores them. Sunscreen, for one,
  was created 2-months-first. Sorting the DOM instead of editing plan rows in
  the app keeps selling-plan IDs stable - printed QR codes point at those IDs.
*/
(function () {
  'use strict';

  function cadenceDays(text) {
    var m = /every\s+(\d+)?\s*(day|week|month|year)/i.exec(text || '');
    if (!m) return 9999;
    var n = m[1] ? parseInt(m[1], 10) : 1;
    return n * { day: 1, week: 7, month: 30, year: 365 }[m[2].toLowerCase()];
  }

  function sortLists() {
    document.querySelectorAll('.shopify_subscriptions_fieldset ul').forEach(function (ul) {
      var items = Array.prototype.slice.call(ul.children).filter(function (li) {
        return li.querySelector('input[data-radio-type="selling_plan"]');
      });
      if (items.length < 2) return;
      items
        .map(function (li, i) {
          var input = li.querySelector('input[data-radio-type="selling_plan"]');
          return { li: li, i: i, days: cadenceDays(input.getAttribute('aria-label')) };
        })
        .sort(function (a, b) { return a.days - b.days || a.i - b.i; })
        .forEach(function (e) { ul.appendChild(e.li); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortLists, { once: true });
  } else {
    sortLists();
  }
  // The app's script hydrates the widget after load; sort once more after it.
  window.addEventListener('load', function () { setTimeout(sortLists, 300); }, { once: true });
})();
